"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryHtmlElementAttributeHandler = void 0;
class InMemoryHtmlElementAttributeHandler {
    data;
    constructor() {
        this.data = new WeakMap;
    }
    #getDataMap(htmlElement) {
        if (!this.data.get(htmlElement)) {
            this.data.set(htmlElement, new Map);
        }
        return this.data.get(htmlElement);
    }
    getAttribute(htmlElement, key) {
        return this.#getDataMap(htmlElement).get(key);
    }
    setAttribute(htmlElement, key, value) {
        this.#getDataMap(htmlElement).set(key, value);
    }
    removeAttribute(htmlElement, key) {
        this.#getDataMap(htmlElement).delete(key);
    }
}
exports.InMemoryHtmlElementAttributeHandler = InMemoryHtmlElementAttributeHandler;
